<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]=""
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.CustomerOrderProcess"
							></div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.CustomerOrderProcess"
							>
								<ng-container *ngIf="screen.request"
									><mat-card>
										<mat-card-header>
											<mat-card-title
												><span
													[innerHtml]="'Order E-mail from customer' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></mat-card-title>
											<mat-card-subtitle
												><span
													[innerHtml]="screen.mail.subject | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></mat-card-subtitle>
										</mat-card-header>

										<mat-card-content>
											<div
												class="layout-block vertical"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<div
													class="layout-block"
													[style.align-items]="'inherit'"
													[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.gap]="'1em'"
												>
													<span
														[style.flex]="'1 0 auto'"
														[innerHtml]="`From: ${screen.mail.from.text}` | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
													<span
														[innerHtml]="Sys.Date.format(screen.mailTimestamp, 'dd.MM.yy, HH:mm') | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</div>
												<span
													style="margin-top: 1em"
													[innerHtml]="screen.mail.html || screen.mail.text | escapeHtml: 'safe' | replaceNewlines: 'span'"
												></span>
											</div>
										</mat-card-content>
									</mat-card>
									<div
										class="layout-block vertical"
										[style.align-items]="'inherit'"
										[style.gap]="'1em'"
									>
										<Orders-CustomerRequestViewInclude
											[$formDirective]="$formDirective"
											[$disabled]="$disabled"
											[$ignoreValidations]="$ignoreValidations"
											[request]="screen.request"
										>
										</Orders-CustomerRequestViewInclude>
										<div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<button
												mat-raised-button
												class="has-click-handler"
												color="primary"
												(click)="handler_ButtonBlock_25_click_$adhoc_0($event, { $disabled: $disabled })"
												[disabled]="$disabled"
											>
												<mat-icon>{{'send'}}</mat-icon
												><span
													[innerHtml]="'Confirm that order has been created manually' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</button>
										</div></div
								></ng-container>
							</div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
